const UnitRounding = Object.freeze({
  HALF_UP: "HALF_UP",
  HALF_DOWN: "HALF_DOWN",
  CEILING: "CEILING",
  FLOOR: "FLOOR",
});

export default UnitRounding;
